import { defineMessages } from "react-intl"

export default defineMessages({
  pageTitle: {
    id: "admin.loginPage.title",
    defaultMessage: "Welcome into your admin space"
  },
  pageSubTitle: {
    id: "admin.loginPage.syncJump",
    defaultMessage: "JUMP referential synchronization"
  },
  usersContent: {
    id: "admin.users.content",
    defaultMessage: "Manage active and inactive users."
  },
  mailContent: {
    id: "admin.mail.content",
    defaultMessage: "Account SMTP & Mail Templates"
  },
  inviteTitle: {
    id: "admin.invite.title",
    defaultMessage: "Invites"
  },
  inviteContent: {
    id: "admin.invite.content",
    defaultMessage: "Invite new users and track pending invitations."
  },
  widgetsContent: {
    id: "admin.widgets.content",
    defaultMessage: "Manage widgets and dashboards."
  },
  reportsTitle: {
    id: "admin.reports.title",
    defaultMessage: "Reports"
  },
  reportsContent: {
    id: "admin.reports.content",
    defaultMessage: "Manage my reports and publish new ones."
  },
  formsTitle: {
    id: "admin.forms.title",
    defaultMessage: "Forms"
  },
  formsContent: {
    id: "admin.forms.content",
    defaultMessage: "Manage, publish, and customize your forms."
  },
  syncDescription: {
    id: "admin.sync.description",
    defaultMessage:
      "The WebPortal referential is synchronized every time the Webportal service is started. However, manual synchronization for some or all of the Webportal domain objects is possible."
  },
  syncBatchDescription: {
    id: "admin.sync.batch.description",
    defaultMessage:
      "If you wish, these APIs are offered via CLI (Command Line Interface) in order to set up regular scheduled tasks."
  },
  syncReferential: {
    id: "admin.sync.all",
    defaultMessage: "Synchronize referential"
  },
  syncTags: {
    id: "admin.sync.tags",
    defaultMessage: "Synchronize tags"
  },
  syncContacts: {
    id: "admin.sync.contacts",
    defaultMessage: "Synchronize contacts"
  },
  syncAttributes: {
    id: "admin.sync.attributes",
    defaultMessage: "Synchronize attributes"
  },
  syncFunds: {
    id: "admin.sync.funds",
    defaultMessage: "Synchronize funds"
  },
  syncIgnoreDuplicates: {
    id: "admin.sync.ignoreDuplicates",
    defaultMessage: "Ignore duplicates"
  },
  syncSuccess: {
    id: "admin.sync.success",
    defaultMessage: "Repository successfully synchronized with JUMP."
  },
  importSuccess: {
    id: "admin.import.resources.success",
    defaultMessage: "Resources successfully imported with JUMP."
  },
  importFailed: {
    id: "admin.import.resources.failed",
    defaultMessage: "Import could not be completed."
  },
  importSuccessNbFiles: {
    id: "admin.import.resources.successNbFiles",
    defaultMessage: "{number} files imported successfuly."
  },
  importNbFilesNotDropped: {
    id: "admin.import.resources.nbFilesNotDropped",
    defaultMessage:
      "{number} files are in the data.csv, but not in the archive."
  },
  importNbFilesNotReferenced: {
    id: "admin.import.resources.nbFilesNotReferenced",
    defaultMessage:
      "{number} files are in an archive, but not in their data.csv."
  },
  syncFailed: {
    id: "admin.sync.failed",
    defaultMessage:
      "Synchronization could not be completed. Is the JUMP service still started?"
  },
  contactSyncFailed: {
    id: "admin.error.sync.contact",
    defaultMessage:
      "Contact synchronization could not be completed. Is the JUMP service still started?"
  },
  tagsSyncFailed: {
    id: "admin.error.sync.tags",
    defaultMessage:
      "tags synchronization could not be completed. Is the JUMP service still started?"
  },
  attributesSyncFailed: {
    id: "admin.error.sync.attributes",
    defaultMessage:
      "attributes Synchronization could not be completed. Is the JUMP service still started?"
  },
  fundsSyncFailed: {
    id: "admin.error.sync.funds",
    defaultMessage:
      "Fund synchronization could not be completed. Is the JUMP service still started?"
  },
  removeUnusedSessionSyncFailed: {
    id: "admin.error.sync.removeUnusedSession",
    defaultMessage:
      "Remove unused session  could not be completed. Is the JUMP service still started?"
  },
  helpTitle: {
    id: "admin.help.title",
    defaultMessage: "Online documentation"
  },
  helpDetails1: {
    id: "admin.help.details1",
    defaultMessage:
      "Do you have a question related to webportal, widget configuration, or learn how to set up forms for your clients?"
  },
  helpDetails2: {
    id: "admin.help.details2",
    defaultMessage:
      "Feel free to consult the on-board documentation regarding the webportal's capabilities."
  },
  helpLink: {
    id: "admin.help.documentation",
    defaultMessage: "Documentation"
  },
  documentationWarning: {
    id: "admin.help.documentation.waning",
    defaultMessage:
      "In development, links to get access to the documentation is disabled. Get an access to the documentation through the webportal-docz project (> yarn dev)."
  },
  mailerServiceName: {
    id: "admin.service.mailer.name",
    defaultMessage: "SMTP mail server connection"
  },
  mailerServiceDescription: {
    id: "admin.service.mailer.description",
    defaultMessage:
      "Indicates the status of the mail server configuration. The mailer is used to communicate with your customers via email, for example, to create a user account."
  },
  referentialServiceName: {
    id: "admin.service.referential.name",
    defaultMessage: "Repository"
  },
  referentialServiceDescription: {
    id: "admin.service.referential.description",
    defaultMessage:
      "Define referential variables and their values. Ensure that the variable names are never duplicated, otherwise the previous value will be overwritten. Variable names must not be empty, otherwise the variable will not be saved. Empty texts are valid values, but empty objects will not be saved."
  },
  sharedResourceDirectoryName: {
    id: "admin.service.shared.resource.name",
    defaultMessage: "Upload shared resources"
  },
  sharedResourceServiceDescription: {
    id: "admin.service.shared.resource.description",
    defaultMessage: "Upload shared resources by import type"
  },
  addNewObject: {
    id: "admin.referential.objectBuilder.addNewObjectButton",
    defaultMessage: "New object variable"
  },
  addNewTextVariable: {
    id: "admin.referential.objectBuilder.addNewTextVariableButton",
    defaultMessage: "New text variable"
  },
  objectNamePlaceholder: {
    id: "admin.referential.objectBuilder.objectNamePlaceholder",
    defaultMessage: "Object name"
  },
  removeObject: {
    id: "admin.referential.objectBuilder.removeObjectButton",
    defaultMessage: "Remove this object and its descendants"
  },
  removeTextVariable: {
    id: "admin.referential.objectBuilder.removeTextVariableButton",
    defaultMessage: "Remove this text variable"
  },
  textVariableNamePlaceholder: {
    id: "admin.referential.objectBuilder.textVariableNamePlaceholder",
    defaultMessage: "Variable name"
  },
  variableValuePlaceholder: {
    id: "admin.referential.objectBuilder.variableValuePlaceholder",
    defaultMessage: "Value"
  },
  databaseServiceName: {
    id: "admin.service.database.name",
    defaultMessage: "Database connection"
  },
  databaseServiceDescription: {
    id: "admin.service.database.description",
    defaultMessage:
      "Indicates the connection status to the webportal database (MongoDB instance)."
  },
  jumpServiceName: {
    id: "admin.service.jump.name",
    defaultMessage: "JUMP Server"
  },
  jumpServiceDescription: {
    id: "admin.service.jump.description",
    defaultMessage:
      "Indicates the connection status to the JUMP server. The JUMP server is used for computing widget data via JUMP Reporting. In case of poor connection, such as during a JUMP Server maintenance, the Webportal may be unresponsive."
  },
  docusignServiceName: {
    id: "admin.service.docusign.name",
    defaultMessage: "Digital signature service"
  },
  docusignServiceDescription: {
    id: "admin.service.docusign.description",
    defaultMessage:
      "Indicates the communication status with the electronic signature service provider. Custom forms that require electronic signatures use this service."
  },
  serviceSuccess: {
    id: "admin.service.success",
    defaultMessage: "Success"
  },
  serviceWarning: {
    id: "admin.service.warning",
    defaultMessage: "Suggested modifications"
  },
  serviceFailure: {
    id: "admin.service.failure",
    defaultMessage: "Service failure: click for more information"
  },
  removeUnusedSessions: {
    id: "admin.sync.sessions",
    defaultMessage: "Remove unused sessions"
  },
  removeExpiredDocuments: {
    id: "admin.sync.expired.doc",
    defaultMessage: "Clean up expired documents"
  },
  importResourcesPublish: {
    id: "admin.import.resources",
    defaultMessage: "Importer les ressources partagées"
  },
  configureAndStatusTitle: {
    id: "admin.config.mainTitle",
    defaultMessage: "Configuration & services status"
  },
  configureInfoText: {
    id: "admin.config.infoText",
    defaultMessage:
      "The webportal communicates with various third-party services. Check the page to see the status of the connections and change the configurations."
  },
  configureSubInfoText: {
    id: "admin.config.subInfoText",
    defaultMessage:
      "Configure the webportal and the integrated services. Some modifications require restarting the application."
  },
  testConfigurationAction: {
    id: "admin.config.testAction",
    defaultMessage: "Test configurations"
  },
  settings: {
    id: "admin.config.settings",
    defaultMessage: "Settings"
  },
  settingsDescription: {
    id: "admin.config.settings.description",
    defaultMessage:
      "Configure webportal global properties, like website title, or contact email for example."
  },
  wealthPageConfigurationTitle: {
    id: "admin.pages.wealth.title",
    defaultMessage: "Configure your wealth pages"
  },
  wealthTabMenu: {
    id: "admin.tabmenu.wealth",
    defaultMessage: "Wealth pages"
  },
  widgetTabMenu: {
    id: "admin.tabmenu.widget",
    defaultMessage: "Widgets"
  },
  wealthSynthesisDescription: {
    id: "admin.pages.wealth.synthesis.description",
    defaultMessage:
      "Display a summary of your customer's accounts, or his family."
  },
  wealthMovementsDescription: {
    id: "admin.pages.wealth.movements.description",
    defaultMessage:
      "See cash flow and operations of your customer's portfolios (dividends, money transfer...)"
  },
  wealthPerformanceDescription: {
    id: "admin.pages.wealth.performance.description",
    defaultMessage: "View the historical performance of portfolios at a glance"
  },
  wealthCompositionDescription: {
    id: "admin.pages.wealth.composition.description",
    defaultMessage: "View the whole composition of your customer's portfolios"
  },
  wealthConsolidationDescription: {
    id: "admin.pages.wealth.consolidation.description",
    defaultMessage:
      "Display a consolidation that does not depend on the different accounts of the customer"
  },
  wealthSimulationsDescription: {
    id: "admin.pages.wealth.simulations.description",
    defaultMessage: "See current simulations of your assets"
  },
  pageFormSettingHideFieldLabel: {
    id: "admin.pages.hidden.label",
    defaultMessage: "Hide page for all users"
  },
  pageFormSettingLimitSelectDateLabel: {
    id: "admin.pages.limit.select.date.max.label",
    defaultMessage: "Limit date picker with today's date as maximum"
  },
  pageFormSettingHidePortfolioDetailsLabel: {
    id: "admin.pages.hidePortfolioDetails",
    defaultMessage: "Hide portfolio details"
  },
  pageFormSettingFrenchTitleFieldLabel: {
    id: "admin.pages.title.fr.label",
    defaultMessage: "Customize french title"
  },
  pageFormSettingEnglishTitleFieldLabel: {
    id: "admin.pages.title.en.label",
    defaultMessage: "Customize english title"
  },
  pageFormSettingLimitAccessTitle: {
    id: "admin.pages.limit.access",
    defaultMessage: "Configure access to user profiles"
  },
  breadcrumbContacts: {
    id: "admin.breadcrumb.contacts",
    defaultMessage: "Contacts"
  },
  breadcrumbPages: {
    id: "admin.breadcrumb.pages",
    defaultMessage: "Wealth pages"
  },
  breadcrumbForms: {
    id: "admin.breadcrumb.forms",
    defaultMessage: "Forms"
  },
  breadcrumbStatements: {
    id: "admin.breadcrumb.statements",
    defaultMessage: "Statements"
  },
  breadcrumbConfiguration: {
    id: "admin.breadcrumb.configuration",
    defaultMessage: "Settings"
  },
  breadcrumbDocuments: {
    id: "admin.breadcrumb.documents",
    defaultMessage: "Documents"
  },
  breadcrumbMails: {
    id: "admin.breadcrumb.mails",
    defaultMessage: "Mails"
  },
  breadcrumbPublishReport: {
    id: "admin.breadcrumb.documents",
    defaultMessage: "Documents"
  },
  breadcrumbLicenseAgreementConfiguration: {
    id: "admin.breadcrumb.licenseAgreementConfiguration",
    defaultMessage: "EULA Configuration"
  },
  overriddenTitle: {
    id: "admin.overridden.title",
    defaultMessage: "Overridden title"
  },
  hidden: {
    id: "admin.hidden",
    defaultMessage: "Hidden"
  },
  limitedAccess: {
    id: "admin.limited.access",
    defaultMessage: "Limited access"
  },
  licenseAgreementTitle: {
    id: "admin.licenseAgreement.title",
    defaultMessage: "End-user license agreement configuration"
  },
  licenseAgreementDescription: {
    id: "admin.licenseAgreement.description",
    defaultMessage:
      "The Webportal can be configured to require users to read and accept an end-user license agreement to use the portal. An end-user license agreement is a legally binding agreement between the owner of the software and the end-user."
  },
  licenseAgreementSwitchLabel: {
    id: "admin.licenseAgreement.switchLabel",
    defaultMessage: "Require license agreement to use the portal"
  },
  licenseAgreementEnabledSwitchSubtitle: {
    id: "admin.licenseAgreement.enabled.switchSubtitle",
    defaultMessage:
      "Users will need to read and agree to the license in order to use the portal."
  },
  licenseAgreementDisabledSwitchSubtitle: {
    id: "admin.licenseAgreement.disabled.switchSubtitle",
    defaultMessage:
      "Users currently do not need to read and agree to the license in order to use the portal."
  },
  configSaveSuccess: {
    id: "admin.config.saveSuccess",
    defaultMessage: "Configuration saved successfully"
  }
})
